var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// enhanced-axios.ts
import axios from 'axios';
import store from '@/store';
/**
 * 增强的Axios类
 */
var EnhancedAxios = /** @class */ (function () {
    function EnhancedAxios(options) {
        if (options === void 0) { options = {}; }
        this.isRefreshing = false;
        this.refreshSubscribers = [];
        this.options = options;
        // 创建axios实例
        this.instance = axios.create(__assign({ baseURL: options.baseURL, timeout: options.timeout || 20000, headers: __assign({ 'Content-Type': 'application/json' }, options.headers) }, options));
        console.log('Axios实例化时的baseURL:', options.baseURL);
        // 设置拦截器
        this.setupInterceptors();
    }
    /**
     * 添加刷新订阅
     */
    EnhancedAxios.prototype.addRefreshSubscriber = function (callback) {
        this.refreshSubscribers.push(callback);
    };
    /**
     * 执行所有刷新订阅
     */
    EnhancedAxios.prototype.onRefreshed = function (token) {
        this.refreshSubscribers.forEach(function (callback) { return callback(token); });
        this.refreshSubscribers = [];
    };
    /**
     * 配置请求和响应拦截器
     */
    EnhancedAxios.prototype.setupInterceptors = function () {
        var _this = this;
        // 请求拦截器
        this.instance.interceptors.request.use(function (config) {
            var _a;
            // 从store获取token 
            var token = store.getters['getAccessToken'];
            if (token && config.headers) {
                config.headers['Authorization'] = "Bearer ".concat(token);
            }
            // 添加websiteid参数（用于多租户支持）
            var websiteId = store.getters['getWebsiteId'] || process.env.VUE_APP_SiteID || '114';
            // 根据请求方法决定参数添加方式
            if (((_a = config.method) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'get') {
                // GET请求：添加到URL参数中
                config.params = __assign(__assign({}, config.params), { websiteId: websiteId });
            }
            else {
                // POST/PUT/DELETE请求：添加到请求体中
                if (config.data && typeof config.data === 'object') {
                    // 如果是FormData，需要特殊处理
                    if (config.data instanceof FormData) {
                        config.data.append('websiteId', websiteId);
                    }
                    else {
                        // 普通对象，直接添加属性
                        config.data = __assign(__assign({}, config.data), { websiteId: websiteId });
                    }
                }
                else {
                    // 如果没有data或data不是对象，创建新的data对象
                    config.data = __assign({ websiteId: websiteId }, (config.data || {}));
                }
            }
            return config;
        }, function (error) {
            return Promise.reject(error);
        });
        // 响应拦截器
        this.instance.interceptors.response.use(function (response) {
            // 如果响应是自定义格式，可以在这里处理
            var data = response.data;
            // 例如API返回格式为 { code: number, data: any, message: string }
            if (data && typeof data === 'object' && 'code' in data) {
                if (data.code === 0 || data.code === 200) {
                    return data.data || data;
                }
                else {
                    var error = new Error(data.message || '服务器返回错误');
                    error.response = response;
                    return Promise.reject(error);
                }
            }
            return data;
        }, function (error) { return __awaiter(_this, void 0, void 0, function () {
            var originalRequest_1, refreshToken, response, tokens, refreshError_1;
            var _this = this;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401 && this.options.refreshTokenConfig && error.config)) return [3 /*break*/, 4];
                        originalRequest_1 = error.config;
                        if (!!((_b = originalRequest_1.url) === null || _b === void 0 ? void 0 : _b.includes(this.options.refreshTokenConfig.url))) return [3 /*break*/, 4];
                        // 如果当前正在刷新，则将请求添加到等待队列
                        if (this.isRefreshing) {
                            return [2 /*return*/, new Promise(function (resolve) {
                                    _this.addRefreshSubscriber(function (token) {
                                        originalRequest_1.headers = originalRequest_1.headers || {};
                                        originalRequest_1.headers['Authorization'] = "Bearer ".concat(token);
                                        resolve(_this.instance(originalRequest_1));
                                    });
                                })];
                        }
                        this.isRefreshing = true;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        refreshToken = store.getters['getRefreshToken'];
                        if (!refreshToken) {
                            throw new Error('没有刷新token');
                        }
                        return [4 /*yield*/, axios({
                                url: this.options.refreshTokenConfig.url,
                                method: this.options.refreshTokenConfig.method || 'POST',
                                data: { refreshToken: refreshToken }
                            })
                            // 处理响应数据，兼容不同的API返回格式
                        ];
                    case 2:
                        response = _c.sent();
                        tokens = void 0;
                        if (response.data.success !== undefined) {
                            // 处理 { success: boolean, data: { accessToken, refreshToken } } 格式
                            tokens = response.data.data;
                        }
                        else if (response.data.accessToken && response.data.refreshToken) {
                            // 处理 { accessToken, refreshToken } 格式
                            tokens = response.data;
                        }
                        else {
                            throw new Error('刷新token失败');
                        }
                        // 更新store中的token
                        store.commit('SET_ACCESS_TOKEN', tokens.accessToken);
                        store.commit('SET_ACCESS_TOKEN', tokens.refreshToken);
                        // 更新当前请求的Authorization头
                        originalRequest_1.headers = originalRequest_1.headers || {};
                        originalRequest_1.headers['Authorization'] = "Bearer ".concat(tokens.accessToken);
                        // 通知所有等待的请求
                        this.onRefreshed(tokens.accessToken);
                        // 重置刷新状态
                        this.isRefreshing = false;
                        // 重新发送原始请求
                        return [2 /*return*/, this.instance(originalRequest_1)];
                    case 3:
                        refreshError_1 = _c.sent();
                        console.error('刷新token失败:', refreshError_1);
                        // 登出用户
                        store.dispatch('logout');
                        window.location.href = '/login';
                        this.isRefreshing = false;
                        return [2 /*return*/, Promise.reject(refreshError_1)];
                    case 4:
                        // 调用错误处理函数
                        if (this.options.errorHandler) {
                            this.options.errorHandler(error);
                        }
                        return [2 /*return*/, Promise.reject(error)];
                }
            });
        }); });
    };
    /**
     * 获取原始axios实例
     */
    EnhancedAxios.prototype.getInstance = function () {
        return this.instance;
    };
    /**
     * GET请求
     */
    EnhancedAxios.prototype.get = function (url, params, config) {
        console.log('请求URL:', url, '当前baseURL:', this.instance.defaults.baseURL);
        return this.instance.get(url, __assign({ params: params }, config));
    };
    /**
     * POST请求
     */
    EnhancedAxios.prototype.post = function (url, data, config) {
        console.log('请求URL:', url, '当前baseURL:', this.instance.defaults.baseURL);
        return this.instance.post(url, data, config);
    };
    /**
     * PUT请求
     */
    EnhancedAxios.prototype.put = function (url, data, config) {
        return this.instance.put(url, data, config);
    };
    /**
     * DELETE请求
     */
    EnhancedAxios.prototype.delete = function (url, config) {
        return this.instance.delete(url, config);
    };
    /**
     * 上传文件
     */
    EnhancedAxios.prototype.upload = function (url, file, fileName, data, config) {
        if (fileName === void 0) { fileName = 'file'; }
        var formData = new FormData();
        formData.append(fileName, file);
        // 如果有其他数据，也加入formData
        if (data) {
            Object.keys(data).forEach(function (key) {
                formData.append(key, data[key]);
            });
        }
        return this.instance.post(url, formData, __assign({ headers: {
                'Content-Type': 'multipart/form-data'
            } }, config));
    };
    return EnhancedAxios;
}());
// 创建Vue插件
export default {
    install: function (app, options) {
        if (options === void 0) { options = {}; }
        var enhancedAxios = new EnhancedAxios(options);
        // 修复类型错误：将整个EnhancedAxios实例提供给全局属性和provide
        app.config.globalProperties.$http = enhancedAxios;
        app.provide('axios', enhancedAxios);
    }
};
